// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2V3tr","containerItemsCenter":"Skeleton_containerItemsCenter__TJLly"};